import React from 'react'
import DatesTable from './components/DateTable/DatesTable'
import Title from '../../../components/Title/Title'
import { importantDates2022 } from '../../../common/constants/importantDates'

const ImportantDates2022page = () => {
  return (
    <>
      <Title>Important Dates</Title>
      <DatesTable array={importantDates2022} />
    </>
  )
}

export default ImportantDates2022page;
